import {
  PATIENT_DOCUMENT_DESCRIPTIONS,
  PATIENT_DOCUMENT_NAMES,
  TRACK_EVENTS,
} from "core/consts";
import { PatientDocumentType, TrackEventFn } from "core/types";
import { onPremHttpRequest } from ".";

export function postPatientDocument({
  careseekerName,
  documentType,
  encodedPdf,
  externalId,
  on_premise_authorization_token,
  on_premise_domain_ssl,
  targetHTML,
  trackEvent,
  userId,
}: {
  careseekerName: string;
  documentType: PatientDocumentType;
  encodedPdf: string;
  externalId: string;
  on_premise_authorization_token: string | undefined;
  on_premise_domain_ssl: string;
  targetHTML: string;
  trackEvent: TrackEventFn;
  userId: string;
}): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const trackImport = (status: number) => {
      trackEvent({
        endpoint: on_premise_domain_ssl,
        name: TRACK_EVENTS.HL7_FILE_EXPORT,
        status,
      });
    };

    let content = "";
    try {
      content = btoa(targetHTML); // Base64 encode the HTML string
    } catch (error) {
      trackImport(-2);
      reject("Encoding failed");
      return;
    }

    const documentName = `${PATIENT_DOCUMENT_NAMES[documentType]}_${userId}`;
    const documentDescription = `${PATIENT_DOCUMENT_DESCRIPTIONS[documentType]}`;

    onPremHttpRequest({
      on_premise_domain_ssl,
      path: `patient/${externalId}/document`,
      method: "POST",
      on_premise_authorization_token,
      body: JSON.stringify({
        content,
        content_pdf: encodedPdf,
        document_type: documentType,
        document_name: documentName,
        document_description: documentDescription,
        patient_id: userId,
        careseeker_name: careseekerName
          .replaceAll("ä", "ae")
          .replaceAll("ö", "oe")
          .replaceAll("ü", "ue")
          .replaceAll(" ", "_"),
      }),
    })
      .then((response) => {
        trackImport(response.status);
        resolve(documentName);
      })
      .catch((err) => {
        trackImport(-1);
        console.error(`Isik transfer type ${documentType} error`, err);
        reject(err);
      });
  });
}
